import React, { useEffect } from 'react';
import {
  useTable, usePagination, useSortBy, useFilters, useGlobalFilter, useRowSelect,
} from 'react-table';
import _ from 'lodash';

import TableUI from '../utils/TableUI';
import ContainerTableUI from '../utils/ContainerTableUI';
import RowCheckbox from '../utils/RowCheckbox';
import TableUIFilter from '../utils/TableUIFilter';

export default React.memo( ( {
  data, columns, onlyTable, manualPagination, defaultPageSize = 10, pageOptions,
  rowSelection, onRowSelect, ...rest
} ) => {
  const {
    getTableProps, headerGroups, page, prepareRow, gotoPage,
    canPreviousPage, previousPage, canNextPage, nextPage, pageCount,
    setPageSize, setGlobalFilter, setFilter, selectedFlatRows,
    state: {
      pageIndex, pageSize, filters, globalFilter,
    },
  } = useTable( {
    data,
    initialState: { pageSize: defaultPageSize },
    manualPagination,
    columns: React.useMemo(
      () => columns,
      [columns],
    ),
  }, useFilters,
  useGlobalFilter,
  useSortBy,
  usePagination,
  useRowSelect,
  ( hooks ) => !!rowSelection
    && hooks.columns.push( ( columnsList ) => [
      {
        id: 'selection',
        disableSorting: true,
        disableTranslate: true,
        customWidth: 40,
        Header: ( { getToggleAllRowsSelectedProps } ) => (
          <RowCheckbox
            {...getToggleAllRowsSelectedProps()}
            rowId="parent"
          />
        ),
        Cell: ( { row } ) => (
          <RowCheckbox
            {...row.getToggleRowSelectedProps()}
            rowId={row.id}
          />
        ),
      },
      ...columnsList,
    ] ) );

  useEffect( () => {
    if ( !rowSelection ) return;
    onRowSelect( selectedFlatRows );
  }, [rowSelection, selectedFlatRows, onRowSelect] );

  if ( onlyTable ) {
    if ( rest.customFilters ) {
      return (
        <TableUIFilter
          {...rest}
          getTableProps={getTableProps}
          headerGroups={headerGroups}
          page={page}
          prepareRow={prepareRow}
          filters={_.fromPairs( _.map( filters, ( i ) => [i.id, i.value] ) )}
          setFilter={setFilter}
          setGlobalFilter={setGlobalFilter}
          globalFilter={globalFilter}
        />
      );
    }
    return (
      <TableUI
        {...rest}
        getTableProps={getTableProps}
        headerGroups={headerGroups}
        page={page}
        prepareRow={prepareRow}
      />
    );
  }
  return (
    <ContainerTableUI
      {...rest}
      getTableProps={getTableProps}
      headerGroups={headerGroups}
      page={page}
      prepareRow={prepareRow}
      gotoPage={gotoPage}
      canPreviousPage={canPreviousPage}
      canNextPage={canNextPage}
      previousPage={previousPage}
      nextPage={nextPage}
      pageIndex={pageIndex}
      pageCount={pageCount}
      setPageSize={setPageSize}
      pageSize={pageSize}
      setFilter={setFilter}
      filters={_.fromPairs( _.map( filters, ( i ) => [i.id, i.value] ) )}
      setGlobalFilter={setGlobalFilter}
      globalFilter={globalFilter}
      pageOptions={pageOptions}
    />
  );
} );
